<template>
  <div>
    <modal id="modalSurescriptCreateDoctor" v-model="modal" :backdrop="false" size="lg">
      <div slot="header">
        <button class="close" type="button" @click.prevent="closeModal">×</button>
        <div class="row">
          <div class="">
            <div :class="{'active': currentTab === 'update'}" class="item-header-nav"
                 @click="selectTab('update')">
              <span v-if="!isEdit"> Create Provider Location</span>
              <span v-if="isEdit"> Update Provider Location <span
                  style="color: red;">({{ item.statusDoctor }})</span></span>
            </div>
            <div :class="{'active': currentTab === 'history'}" class="item-header-nav"
                 @click="selectTab('history')">History
            </div>

          </div>
        </div>
      </div>
      <div v-show="currentTab === 'update'" class="tab-1">
        <div class="block-body">
          <h4><b>Provider Name</b></h4>
          <div class="block-item">
            <h6>Name</h6>
            <div class="row">
              <div class=" col-sm-1">
                <label for="prefix">Prefix</label>
                <input id="prefix"
                       v-model="item.prefix"
                       class=""
                       maxlength="10"
                       name="prefix"
                       type="text">
              </div>
              <div class=" col-sm-4 col-lg-3 required">
                <label for="firstName">First Name <span class="text-color">*</span></label>
                <input id="firstName" v-model="item.firstName"
                       class=""
                       maxlength="35"
                       name="firstName"
                       type="text">
              </div>
              <div class=" col-sm-2"><label for="middleName">Middle Name</label>
                <input id="middleName" v-model="item.middleName" class="" maxlength="35"
                       name="middleName" type="text">
              </div>
              <div class=" col-sm-4 col-lg-3 required">
                <label for="lastName">Last Name <span class="text-color">*</span></label>
                <input id="lastName"
                       v-model="item.lastName" class="" maxlength="35" name="lastName"
                       type="text">
              </div>
              <div class=" col-sm-1"><label for="suffix">Suffix</label>
                <input id="suffix"
                       v-model="item.suffix"
                       class=" "
                       maxlength="10"
                       name="suffix"
                       type="text">

              </div>
            </div>
          </div>
          <div class="block-item">
            <h6>Former Name</h6>
            <div class="row">
              <div class=" col-sm-1">
                <label for="formerPrefix">Prefix</label>
                <input id="formerPrefix"
                       v-model="item.formerPrefix"
                       class=""
                       maxlength="10"
                       type="text">
              </div>
              <div class=" col-sm-4 col-lg-3 required">
                <label for="formerFirstName">First Name</label>
                <input id="formerFirstName" v-model="item.formerFirstName"
                       class=""
                       maxlength="35"
                       name="formerFirstName"
                       type="text">
              </div>
              <div class=" col-sm-2"><label for="formerMiddleName">Middle Name</label>
                <input id="formerMiddleName" v-model="item.formerMiddleName" class=""
                       maxlength="35"
                       name="formerMiddleName" type="text">
              </div>
              <div class=" col-sm-4 col-lg-3 required">
                <label for="formerLastName">Last Name </label>
                <input id="formerLastName"
                       v-model="item.formerLastName" class="" maxlength="35" name="lastName"
                       type="text">
              </div>
              <div class=" col-sm-1"><label for="formerSuffix">Suffix</label>
                <input id="formerSuffix" v-model="item.formerSuffix" class=" " maxlength="10"
                       name="formerSuffix" type="text">
              </div>
            </div>
          </div>

          <div class="block-item">
            <div class="row">
              <div class=" col-md-6">
                <label>Specialty Code</label>
                <span class="selectwrap">
                                <select v-model="item.specialty" style="margin-left: 0px !important;">
                                    <option v-for="itemCode in LIST_SPECIALTY_CODE" :value="itemCode.id">{{ itemCode.name }} | {{itemCode.id}}</option>
                                </select>
                            </span>
              </div>
            </div>
          </div>
          <h4><b>Location</b></h4>
          <div class="block-item">
            <div class="">
              <div class="row">
                <div class="col-md-8">
                  <div class="row">
                    <div class="form-group col-md-6"
                         formgroupname="location">
                      <label for="locationName">Business Name</label>
                      <input id="locationName"
                             v-model="item.businessName"
                             class=" " maxlength="70"
                             name="locationName"
                             type="text">
                    </div>
                  </div>
                  <div class="row">
                    <div class=" col-sm col-md-2">
                      <label for="npi">NPI <span class="text-color">*</span></label>
                      <input id="npi"
                             v-model="item.npi"
                             class="form-control "
                             maxlength="10"
                             name="npi"
                             type="text">
                    </div>
                    <div v-if="itemSpi" class=" col-sm col-md-2">
                      <label for="npi">SPI </label>
                      <input id="npi"
                             v-model="itemSpi"
                             class="form-control "
                             name="spi"
                             readonly
                             type="text">
                    </div>
                  </div>

                  <div class="row">
                    <div class="form-group col-sm-7"><label for="organizationId">Organization Id</label><input
                        id="organizationId" v-model="item.organizationId" class="form-control"
                        maxlength="100" name="organizationId"
                        type="text"></div>
                  </div>
                  <div class="row">
                    <div class="form-group col-sm col-md-3">
                      <label for="deaNumber">DEA</label>
                      <input id="deaNumber" v-model="item.deaNumber" class="form-control" maxlength="35"
                             name="deaNumber"
                             type="text">
                      <div v-if="deaText">{{ deaText }}</div>
                    </div>
                    <div class="form-group col-sm col-md-3"><label
                        for="stateLicense">State License</label>
                      <input id="stateLicense"
                             v-model="item.stateLicense"
                             class="form-control"
                             maxlength="35" name="stateLicense"
                             type="text">
                    </div>
                    <div class="form-group col-sm-4 mt-4">
                      <div class="form-check" style="margin-top: 40px">
                        <input id="veterinarian" v-model="item.veterinarian"
                               class="form-check-input" name="veterinarian"
                               type="checkbox"><label
                          class="form-check-label" for="veterinarian"> &nbsp;Veterinarian </label>
                      </div>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-sm-12" @click="openAdditionalId = !openAdditionalId"><a
                        href="javascript:void(0)" style="color: #005677;"
                    >
                      Additional Ids <i v-if="openAdditionalId" class="fas fa-caret-down"></i>
                      <i v-if="!openAdditionalId" class="fas fa-caret-right"></i>
                    </a>
                    </div>
                  </div>
                  <div class="row">
                    <div v-show="openAdditionalId" id="additionalIdContainer" class="col-md-12">
                      <div class="card">
                        <div class="card-body">
                          <div class="row">
                            <div class="form-group col-sm-4"><label for="medicaidNumber">Medicaid Number</label><input
                                id="medicaidNumber" v-model="item.medicaidNumber"
                                class="form-control " maxlength="35" name="medicaidNumber"
                                type="text">
                            </div>
                            <div class="form-group col-sm-4"><label
                                for="upin">UPIN</label>
                              <input id="upin" v-model="item.upin"
                                     class="form-control "
                                     maxlength="35" name="upin"
                                     type="text">
                            </div>
                            <div class="form-group col-sm-4"><label for="data2000WaiverId">Data 2000 Waiver Id</label>
                              <input
                                  id="data2000WaiverId" v-model="item.data2000WaiverId"
                                  class="form-control " maxlength="35"
                                  name="data2000WaiverId"
                                  type="text">
                            </div>
                          </div>
                          <div class="row">
                            <div class="form-group col-sm-4"><label for="medicareNumber">Medicare Number</label>
                              <input
                                  id="medicareNumber" v-model="item.medicareNumber"
                                  class="form-control " maxlength="35" name="medicareNumber"
                                  type="text">
                            </div>
                            <div class="form-group col-sm-4"><label for="mutuallyDefined">Mutually Defined</label>
                              <input
                                  id="mutuallyDefined" v-model="item.mutuallyDefined"
                                  class="form-control " maxlength="35"
                                  name="mutuallyDefined"
                                  type="text">
                              <!----></div>
                            <div class="form-group col-sm-4"><label
                                for="remsHealthcareProviderEnrollmentId">REMS Healthcare Provider Enrollment Id</label>
                              <input
                                  id="remsHealthcareProviderEnrollmentId"
                                  v-model="item.remsHealthcareProviderEnrollmentId"
                                  class="form-control "
                                  maxlength="35" name="remsHealthcareProviderEnrollmentId"
                                  type="text">
                            </div>
                          </div>
                          <div class="row">
                            <div class="form-group col-sm-4"><label for="socialSecurity">Social Security</label><input
                                id="socialSecurity" v-model="item.socialSecurity"
                                class="form-control " maxlength="35" name="socialSecurity"
                                type="text">
                            </div>
                            <div class="form-group col-sm-4"><label
                                for="certificateToPrescribe">Certificate To Prescribe</label><input
                                id="certificateToPrescribe" v-model="item.certificateToPrescribe"
                                class="form-control " maxlength="35"
                                name="certificateToPrescribe"
                                type="text">
                            </div>
                            <div class="form-group col-sm-4"><label
                                for="stateControlSubstanceNumber">State Control Substance Number</label><input
                                id="stateControlSubstanceNumber"
                                v-model="item.stateControlSubstanceNumber"
                                class="form-control " maxlength="35"
                                name="stateControlSubstanceNumber"
                                type="text">
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="clearfix"></div>
                  </div>
                </div>
                <div class="col-md-4">
                </div>
              </div>
            </div>
          </div>
          <h4><b>Address</b></h4>
          <div class="block-item">
            <div class="">
              <div class="row">
                <div class="col-md-8 ">
                  <div class="row">
                    <div class="form-group col-sm-12 required">
                      <label
                          for="addressLine1">Address Line 1 <span
                          class="text-color">*</span></label>
                      <input id="addressLine1"
                             v-model="item.addressLine1"
                             class="form-control"
                             maxlength="40" name="addressLine1"
                             required=""
                             type="text">
                    </div>
                  </div>
                  <div class="row">
                    <div class="form-group col-sm-12">
                      <label
                          for="addressLine2">Address Line 2</label>
                      <input id="addressLine2"
                             v-model="item.addressLine2"
                             class="form-control "
                             maxlength="40" name="addressLine2"
                             type="text">
                    </div>
                  </div>
                  <div class="row">
                    <div class="form-group col-sm-4 required">
                      <label for="city">City <span class="text-color">*</span></label><input
                        id="city" v-model="item.city" class="form-control" maxlength="35" name="city"
                        required="" type="text">
                    </div>
                    <div class="form-group col-sm-2 required">
                      <label for="state">State <span class="text-color">*</span></label>
                      <span class="selectwrap">
                                            <select
                                                id="state"
                                                v-model="item.state" name="state" required=""

                                                style="margin-left: 0px !important;">
                                                <option selected="" value="">-- All --</option>
                                                <option v-for="state in US_STATES"
                                                        :value="state.code">{{ state.name }}</option>

                                            </select>
                                         </span>
                    </div>
                    <div class="form-group col-sm col-md-2 required">
                      <label
                          for="postalCode">Zip <span class="text-color">*</span></label><input
                        id="postalCode" v-model="item.postalCode" class="form-control" maxlength="10"
                        name="postalCode"
                        required="" type="text">
                    </div>
                    <div class="form-group col-sm-2 required">
                      <label
                          for="countryCode">Country Code <span
                          class="text-color">*</span></label>
                      <input id="countryCode"
                             v-model="item.countryCode"
                             class="form-control"
                             maxlength="2" name="countryCode"
                             required=""
                             type="text">
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <h4><b>Contact</b></h4>
          <div class="block-item">
            <div class="">
              <div class="row ng-touched ng-dirty ng-valid" formgroupname="location">
                <div class="form-group col-sm-5"><label for="directAddress">Direct Address</label><input
                    id="directAddress" v-model="item.directAddress" class="form-control" maxlength="254"
                    name="directAddress" type="text"><!----><!---->
                </div><!----></div>
              <div class="row " formgroupname="location">
                <div class="form-group col-sm-5">
                  <label for="email">Email Address</label>
                  <input id="email"
                         v-model="item.electronicMail"
                         class="form-control"
                         maxlength="80"
                         name="email"
                         type="text">
                  <!----></div>
              </div>
              <div class="row">
                <div class="">
                  <div>
                    <div class="form-group col-md-4 required"><label
                        for="Primary_number">Primary Number <span
                        class="text-color">*</span></label><input
                        id="Primary_number" v-model="item.primaryTelephone" class="form-control"
                        maxlength="10" name="Primary_number"
                        type="text"><!----><!----></div>
                    <div class="form-group col-md-4"><label
                        for="Primary_extension">Extension</label>
                      <input id="Primary_extension"
                             v-model="item.primaryExtension" class="form-control "
                             maxlength="8"
                             name="Primary_extension"
                             type="text">
                      <!----><!----></div>
                    <div class="col-md-4" style="margin-top: 40px">
                      <div class="form-check form-group">
                        <input id="Primary_supportsSms"
                               v-model="item.primarySupportSms"
                               class="form-check-input"
                               name="Primary_supportsSms"
                               type="checkbox">
                        <label class="form-check-label" for="Primary_supportsSms">
                          &nbsp;Supports SMS </label>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="">
                  <div class="">
                    <div class="form-group col-md-4 required">
                      <label
                          for="Fax_number">Fax Number
                        <small>(Must be PHI Secure - This field require when using service ePA: Electronic Prior Authorization)</small>
                        <span class="text-color">*</span>
                      </label>
                      <input id="Fax_number" v-model="item.faxNumber" class="form-control "
                             maxlength="10" name="Fax_number"
                             type="text">
                    </div>
                    <div class="form-group col-md-4"><label for="Fax_extension">Extension</label><input
                        id="Fax_extension" v-model="item.faxExtension" class="form-control"
                        maxlength="8" name="Fax_extension"
                        type="text"><!----><!----></div>
                    <div class="col-md-4" style="margin-top: 40px">
                      <div class="form-check form-group">
                        <input id="Fax_supportsSms"
                               v-model="item.faxSupportSms"
                               class="form-check-input"
                               name="Fax_supportsSms"
                               type="checkbox"><label
                          class="form-check-label" for="Fax_supportsSms">
                        &nbsp;Supports SMS </label>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div v-for="(otherPhone, indexOtherPhone) in item.otherPhones" class="row">
                <div class="">
                  <div class="col-md-7 ">
                    <div class="row ">
                      <div class="form-group col-md-3 required">
                        <label>Type <span class="text-color">*</span></label>
                        <span class="selectwrap">
                                            <select v-model="otherPhone.qualifier">
                                                <option value="HomeTelephone">Home</option>
                                                <option value="WorkTelephone">Work</option>
                                                <option value="Beeper">Beeper</option>
                                                <option value="OtherTelephone">Other</option>
                                            </select>
                                                </span>
                      </div>
                      <div class="form-group col-md-3">
                        <label> Number <span class="text-color">*</span></label>
                        <input v-model="otherPhone.number"
                               class="form-control " maxlength="10"
                               type="text"

                        >
                      </div>
                      <div class="form-group col-md-3"><label
                          for="1_extension">Extension</label>
                        <input id="1_extension"
                               v-model="otherPhone.extension" class="form-control "
                               maxlength="8"
                               name="1_extension"
                               type="text"><!---->
                        <!----></div>
                      <div class="col-md-2" style="margin-top: 40px">
                        <div class="form-check form-group">
                          <input :id="indexOtherPhone + 'other-phone-support'"
                                 v-model="otherPhone.supportsSms"
                                 class="form-check-input "
                                 type="checkbox"
                          ><label
                            :for="indexOtherPhone + 'other-phone-support'"
                            class="form-check-label">&nbsp;
                          Supports SMS </label>
                        </div>
                      </div>
                      <div class="col-md-1" style="margin-top: 40px">
                        <div @click.prevent="removeOtherPhones(indexOtherPhone)"><i
                            aria-hidden="true" class="fa fa-times"></i></div>

                      </div><!---->

                    </div>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col">
                  <div class="">
                    <div class=""><!---->
                      <button class="btn btn-secondary" type="button" @click.prevent="addOtherPhone">
                        Add Phone
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <h4><b>Configuration</b></h4>
          <div class="block-item">
            <div class="">
              <div class="row">
                <div class="form-group col-md-3 required">
                  <label for="activeStartTime"><b>Active Start Date </b><span
                      class="text-color">*</span>
                  </label>
                  <input id="activeStartTime-input" v-model="item.activeStartTime" class="form-control"
                         disabled="" type="text">
                </div>
                <div class="form-group col-sm-3 required">
                  <label for="activeEndTime"><b>Active End Date </b>
                    <span class="text-color">*</span></label>

                  <date-picker v-model="item.activeEndTime"
                               :append-to-body="true"
                               :clearable="false"
                               format="MM/DD/YYYY hh:mm:ss A"
                               lang="en"
                               placeholder="Select from date"
                               type="datetime"></date-picker>
                </div>
                <div class="col-md-12 row">
                  <!--<div class="form-group col-sm-3">-->
                  <!--<label>Delivery Overrides</label>-->
                  <!--<div class="form-check">-->
                  <!--<input id="renewalFaxOptOut" name="renewalFaxOptOut"-->
                  <!--v-model="item.optOutFlags.renewalFaxOptOut" type="checkbox"-->
                  <!--class="form-check-input "><label-->
                  <!--for="renewalFaxOptOut" class="form-check-label">-->
                  <!--&nbsp; Do NOT Fax Refill Messages </label>-->
                  <!--</div>-->
                  <!--<div class="form-check">-->
                  <!--<input id="ciMailOptOut" name="ciMailOptOut"-->
                  <!--v-model="item.optOutFlags.ciMailOptOut" type="checkbox"-->
                  <!--class="form-check-input"><label-->
                  <!--for="ciMailOptOut" class="form-check-label">-->
                  <!--&nbsp; Do NOT Postal Mail Clinical Messages </label>-->
                  <!--</div>-->
                  <!--<div class="form-check">-->
                  <!--<input id="ciFaxOptOut" name="ciFaxOptOut"-->
                  <!--v-model="item.optOutFlags.ciFaxOptOut" type="checkbox"-->
                  <!--class="form-check-input ">-->
                  <!--<label for="ciFaxOptOut" class="form-check-label">-->
                  <!--&nbsp; Do NOT Fax Clinical Messages </label>-->
                  <!--</div>-->
                  <!--</div>-->
                  <div class="form-group col-sm-4"><label>Other Settings</label>
                    <div class="form-check">
                      <input id="backupPortalId" v-model="item.backupPortalId" class="form-check-input "
                             name="backupPortalId" type="checkbox">
                      <label class="form-check-label" for="backupPortalId">&nbsp; Fax Backup </label>
                    </div>
                    <div class="form-check">
                      <input id="test" v-model="item.test" class="form-check-input" name="test"
                             type="checkbox">
                      <label class="form-check-label" for="test">&nbsp; Test</label>
                    </div>
                  </div>
                </div>
                <div class="row col-md-12">
                  <div class="form-group col-sm-3">
                    <label for="directorySpecialties">Directory Specialties</label>
                    <multi-select v-model="item.directorySpecialties"
                                  :filterable="true" :options="LIST_DIRECTORY_SPECIALTIES" block
                                  class="multi-select-block"
                                  selected-icon=""
                                  size="lg"
                    ></multi-select>
                  </div><!---->
                  <div class="form-group col-sm-3">
                    <label for="useCases">Use Cases</label>
                    <multi-select v-model="item.useCases"
                                  :filterable="true" :options="LIST_USE_CASES" block
                                  class="multi-select-block"
                                  selected-icon=""
                                  size="lg"
                    ></multi-select>
                  </div>
                  <div class="form-group col-sm-3 required"><label
                      for="serviceLevels">Service Levels</label>
                    <multi-select v-model="item.serviceLevels"
                                  :filterable="true" :options="LIST_SERVICE_LEVELS" block
                                  class="multi-select-block"
                                  selected-icon=""
                                  size="lg"
                    ></multi-select>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="clearfix"></div>
        </div>
      </div>
      <div v-if="currentTab === 'history'" class="tab-2 ">
          <history-approval-epcs :doctor="user"></history-approval-epcs>
      </div>
      <div slot="footer">
        <template v-if="currentTab === 'update' && canDoAction">
          <button v-if="isEdit" class="btn btn-default" type="button" @click.prevent="syncDataDoctor">
            <i v-if="isProcessing" class="fas fa-spinner fa-spin"></i>
            Sync data from SureScript
          </button>
          <button v-if="isEdit && item.statusDoctor !== 'Disable'" class="btn btn-default"
                  type="button"
                  @click.prevent="disableDoctor">
            <i v-if="isProcessing" class="fas fa-spinner fa-spin"></i>
            Disable
          </button>
          <button v-if="isEdit && item.statusDoctor === 'Disable'" class="btn btn-default" type="button"
                  @click.prevent="handleAction">
            <i v-if="isProcessing" class="fas fa-spinner fa-spin"></i>
            Enable
          </button>
          <button class="btn btn-default" type="button" @click.prevent="handleAction"><i
              v-if="isProcessing" class="fas fa-spinner fa-spin"></i>
            <span v-if="!isEdit">Create</span>
            <span v-if="isEdit"><span v-if="changeControlledSubstance()">Submit for Approval</span> <span
                v-else>Update</span></span>
          </button>
        </template>
        <button class="btn btn-default" type="button" @click.prevent="closeModal">Close</button>
      </div>
    </modal>

    <modal id="modalDetailSureScript" v-model="modalDetail" :backdrop="false" size="lg">
      <div slot="header">
        <button class="close" type="button" @click.prevent="closeModalDetail">×</button>
        <div class="row">
          <div class="col-xs-6"><h4 class="smalltitle">Provider Location Details</h4></div>
        </div>
      </div>
      <div class="block-body">
        <div class="form-row mt-3 col-md-12">
          <div class="col">
            <div class="card-deck">
              <div class="card block-item-card">
                <div class="card-header"><h5>Provider</h5></div>
                <div class="card-body"><h6 class="card-subtitle mb-2 text-muted">SPI: {{ detailDoctor.SPI }}</h6>
                  <div class="form-row">
                    <div class="col">
                      <div class="form-group"><label>Name</label><span
                          class="form-text"> {{ detailDoctor.FirstName }} {{ detailDoctor.LastName }}</span>
                      </div>
                    </div>
                    <div class="col"></div>
                  </div>
                  <div class="form-row">
                    <div class="col">
                      <div class="form-group">
                        <label>Specialty</label>
                        <span class="form-text">{{ getSpecialtyText }}</span></div>
                    </div>
                  </div>
                </div>

              </div>
              <div class="card block-item-card">
                <div class="card-header"><h5>Clinic</h5></div>
                <div class="card-body">
                  <!--<h6 class="card-subtitle mb-2 text-muted">Location Id: 005</h6>-->
                  <div class="form-row">
                    <div class="col-sm-6">
                      <div class="form-group"><label
                      >Business Name</label><span
                          class="form-text">{{ detailDoctor.BusinessName ? detailDoctor.BusinessName : 'N/A' }}</span>
                      </div>
                      <div class="form-group">
                        <label>NPI</label>
                        <span class="form-text">{{ detailDoctor.NPI }}</span>
                      </div>

                    </div>
                    <div class="col-sm-6"><!----><!----><!---->
                      <div class="form-group">
                        <label>Veterinarian</label>
                        <span class="form-text"> {{ detailDoctor.Veterinarian }}</span>
                      </div>
                    </div>
                  </div>
                </div>
              </div><!----></div>
          </div>
        </div>
        <div class="form-row mt-3 col-md-12">
          <div class="col">
            <div class="card-deck">
              <div class="card block-item-card">
                <div class="card-header"><h5>Contact</h5></div>
                <div class="card-body">
                  <div class="col-sm-6">
                    <div class="col">
                      <div class="form-group"><label>Address</label>
                        <div>
                          <div>{{ detailDoctor.AddressLine1 }}</div>
                          <div>{{ detailDoctor.AddressLine2 }}</div>
                          <div>
                            {{ detailDoctor.City }}, {{ detailDoctor.StateProvince }} {{ detailDoctor.PostalCode }}
                            {{ detailDoctor.CountryCode }}
                          </div>
                        </div>
                      </div><!----></div>
                    <div class="col">
                      <!--<div class="form-group"><label>USPS Standard Address</label>-->
                      <!--<div>-->
                      <!--<div> Ha Noi </div>-->
                      <!--<div></div>-->
                      <!--<div> Schenectady, NY 12345 </div>-->
                      <!--</div>-->
                      <!--</div>-->
                    </div>
                  </div><!----><!---->
                  <div class="col-sm-6">
                    <div class="col">
                      <div class="form-group"><label>Primary Phone</label>
                        <span class="form-text">
                                                    <span>{{ formatPhone(detailDoctor.PrimaryTelephone) }}</span>
                                                    <span> {{ detailDoctor.PrimaryExtension }}</span>
                                                    &nbsp;
                                                    <span v-if="detailDoctor.PrimarySupportsSMS === 'Y'">
                                                            <svg aria-labelledby="svg-inline--fa-title-9n0EXntBUO7Q"
                                                                 class="svg-inline--fa fa-comments fa-xs"
                                                                 data-icon="comments" data-prefix="fas"
                                                                 role="img"
                                                                 viewBox="0 0 640 512"
                                                                 xmlns="http://www.w3.org/2000/svg"><title
                                                                id="svg-inline--fa-title-9n0EXntBUO7Q">Supports SMS</title><path
                                                                d="M416 176C416 78.8 322.9 0 208 0S0 78.8 0 176c0 39.57 15.62 75.96 41.67 105.4c-16.39 32.76-39.23 57.32-39.59 57.68c-2.1 2.205-2.67 5.475-1.441 8.354C1.9 350.3 4.602 352 7.66 352c38.35 0 70.76-11.12 95.74-24.04C134.2 343.1 169.8 352 208 352C322.9 352 416 273.2 416 176zM599.6 443.7C624.8 413.9 640 376.6 640 336C640 238.8 554 160 448 160c-.3145 0-.6191 .041-.9336 .043C447.5 165.3 448 170.6 448 176c0 98.62-79.68 181.2-186.1 202.5C282.7 455.1 357.1 512 448 512c33.69 0 65.32-8.008 92.85-21.98C565.2 502 596.1 512 632.3 512c3.059 0 5.76-1.725 7.02-4.605c1.229-2.879 .6582-6.148-1.441-8.354C637.6 498.7 615.9 475.3 599.6 443.7z"
                                                                fill="currentColor"></path></svg>
                                                    </span>
                                                </span>

                      </div>
                      <div class="form-group"><label>Fax</label>
                        <span
                            class="form-text"><span>{{
                            formatPhone(detailDoctor.FaxNumber)
                          }}</span><span> {{ detailDoctor.FaxExtension }}</span>
                                                 &nbsp;
                                                    <span v-if="detailDoctor.FaxSupportsSMS === 'Y'">
                                                            <svg aria-labelledby="svg-inline--fa-title-9n0EXntBUO7Q"
                                                                 class="svg-inline--fa fa-comments fa-xs"
                                                                 data-icon="comments" data-prefix="fas"
                                                                 role="img"
                                                                 viewBox="0 0 640 512"
                                                                 xmlns="http://www.w3.org/2000/svg"><title
                                                                id="svg-inline--fa-title-9n0EXntBUO7Q">Supports SMS</title><path
                                                                d="M416 176C416 78.8 322.9 0 208 0S0 78.8 0 176c0 39.57 15.62 75.96 41.67 105.4c-16.39 32.76-39.23 57.32-39.59 57.68c-2.1 2.205-2.67 5.475-1.441 8.354C1.9 350.3 4.602 352 7.66 352c38.35 0 70.76-11.12 95.74-24.04C134.2 343.1 169.8 352 208 352C322.9 352 416 273.2 416 176zM599.6 443.7C624.8 413.9 640 376.6 640 336C640 238.8 554 160 448 160c-.3145 0-.6191 .041-.9336 .043C447.5 165.3 448 170.6 448 176c0 98.62-79.68 181.2-186.1 202.5C282.7 455.1 357.1 512 448 512c33.69 0 65.32-8.008 92.85-21.98C565.2 502 596.1 512 632.3 512c3.059 0 5.76-1.725 7.02-4.605c1.229-2.879 .6582-6.148-1.441-8.354C637.6 498.7 615.9 475.3 599.6 443.7z"
                                                                fill="currentColor"></path></svg>
                                                    </span>
                                                </span>
                      </div>
                    </div>

                  </div>
                </div>
              </div>
              <div class="card block-item-card">
                <div class="card-header"><h5>Configuration</h5></div>
                <div class="card-body">
                  <div class="form-row">
                    <div class="col-sm-6">
                      <div class="form-group"><label>Enabled Dates </label><span
                          class="form-text"> {{
                          formatTime(detailDoctor.ActiveStartTime)
                        }} - {{ formatTime(detailDoctor.ActiveEndTime) }}</span>
                      </div>
                      <!--<div class="form-group"><label>5 NewRx Sent </label>-->
                      <!--<span class="form-text">5 NewRx not sent</span></div>-->
                      <div class="form-group"><label>Directory Specialties</label>

                        <span v-for="item in detailDoctor.DirectorySpecialties"
                              class="form-text"><span
                            class="badge badge-pill badge-ss mr-1 mb-1">{{ item }}</span>
                                                </span>
                      </div>
                      <div class="form-group"><label>Service Levels</label>
                        <span v-for="(item,index) in detailDoctor.ServiceLevels" :key="index"
                              class="form-text">
                          <span class="badge badge-pill badge-ss mr-1 mb-1">{{ item }}</span>
                                              </span>
                      </div>
                    </div>
                    <div class="col-sm-6"><!---->
                      <div class="form-group"><label>Fax Backup</label>
                        <div class="form-text"> {{ detailDoctor.FaxBackup }}</div>
                      </div><!---->
                      <div class="form-group"><label>Test</label>
                        <div class="form-text"> {{ detailDoctor.Test }}</div>
                      </div><!----><!----></div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="clearfix"></div>
      </div>
      <div slot="footer">

        <button class="btn btn-default" type="button" @click.prevent="closeModalDetail">Close</button>
      </div>
    </modal>
  </div>

</template>

<script>

import DatePicker from 'vue2-datepicker'
import httpClient from '../../../client'
import SureScriptConfig from '../../../config/surescript'
import HistoryApprovalEpcs from './../part/doctor/HistoryApprovalEpcs.vue'
import StateConfig from '../../../config/state'
import CommonMixin from '../../mixins/Common.vue'
import moment from 'moment'

export default {
  name: 'SureScriptModal',
  components: { DatePicker, HistoryApprovalEpcs },
  props: {
    user: {}
  },
  mixins: [CommonMixin],
  data () {
    return {
      isProcessing: false,
      modal: false,
      isLoading: true,
      US_STATES: StateConfig.US_STATES,
      currentTab: 'update',

      item: {
        prefix: '',
        firstName: '',
        middleName: '',
        suffix: '',

        formerPrefix: '',
        formerFirstName: '',
        formerMiddleName: '',
        formerLastName: '',
        formerSuffix: '',

        specialty: '',
        organizationId: '',
        businessName: '',
        deaNumber: '',
        stateLicense: '',
        veterinarian: '',

        medicaidNumber: '',
        upin: '',
        data2000WaiverId: '',
        medicareNumber: '',
        mutuallyDefined: '',
        remsHealthcareProviderEnrollmentId: '',
        socialSecurity: '',
        certificateToPrescribe: '',
        stateControlSubstanceNumber: '',

        addressLine1: '',
        addressLine2: '',
        city: '',
        state: '',
        postalCode: '',
        countryCode: 'US',

        directAddress: '',
        electronicMail: '',
        primaryTelephone: '',
        primaryExtension: '',
        primarySupportSms: false,

        faxNumber: '',
        faxExtension: '',
        faxSupportSms: false,
        otherPhones: [],

        activeStartTime: '',
        activeEndTime: '',

        optOutFlags: {
          renewalFaxOptOut: false,
          ciMailOptOut: false,
          ciFaxOptOut: false
        },
        backupPortalId: false,
        test: false,

        directorySpecialties: [],
        useCases: [],
        serviceLevels: []
      },
      deaText: '',
      itemSpi: '',
      LIST_SPECIALTY_CODE: SureScriptConfig.LIST_SPECIALTY_CODE,
      LIST_DIRECTORY_SPECIALTIES: SureScriptConfig.LIST_DIRECTORY_SPECIALTIES,
      LIST_USE_CASES: SureScriptConfig.LIST_USE_CASES,
      LIST_SERVICE_LEVELS: SureScriptConfig.LIST_SERVICE_LEVELS,
      openAdditionalId: false,
      modalDetail: false,
      detailDoctor: {},
      currentDetailDoctor: {}
    }
  },
  computed: {
    canDoAction () {
      return !this.requestUpdateControlledSubstance
    },
    getSpecialtyText () {
      if (this.detailDoctor && this.detailDoctor.Specialty) {
        let index = this.LIST_SPECIALTY_CODE.findIndex(item => item.id === this.detailDoctor.Specialty)
        if (index > -1) {
          return `${this.LIST_SPECIALTY_CODE[index].id}: ${this.LIST_SPECIALTY_CODE[index].name}`
        }
      }
      return ''
    },
    isEdit () {
      return this.itemSpi
    }
  },
  watch: {
    'modal' (newValue, oldValue) {
      this.$emit('updateModal', newValue)
    },
    'modalDetail' (newValue, oldValue) {
      this.$emit('updateModal', newValue)
    }
  },
  updated () {
  },
  mounted () {
    this.item.activeStartTime = moment().format('MM/DD/YYYY hh:mm:ss A')
    this.item.activeEndTime = moment('12/31/2099 12:00:00 AM', 'MM/DD/YYYY hh:mm:ss A')
    this.initDataModal()
  },
  beforeDestroy () {
  },
  methods: {
    selectTab (tab) {
      this.currentTab = tab
    },
    changeControlledSubstance () {
      if (!this.isEdit) {
        return false
      }
      const existedOldData = this.currentDetailDoctor.serviceLevels.indexOf('ControlledSubstance') >= 0
      const existedNewData = this.item.serviceLevels.indexOf('ControlledSubstance') >= 0
      return existedNewData !== existedOldData
    },
    initDataUpdate (data) {
      this.itemSpi = data.SPI
      this.currentDetailDoctor = { serviceLevels: data.ServiceLevels ? data.ServiceLevels : [] }
      this.item = {
        statusDoctor: data.statusDoctor,
        prefix: data.Prefix,
        firstName: data.FirstName,
        middleName: data.MiddleName,
        lastName: data.LastName,
        suffix: data.Suffix,

        formerPrefix: data.FormerPrefix,
        formerFirstName: data.FormerFirstName,
        formerMiddleName: data.FormerMiddleName,
        formerLastName: data.FormerLastName,
        formerSuffix: data.FormerSuffix,

        specialty: data.Specialty,
        businessName: data.BusinessName,
        npi: data.NPI,
        organizationId: data.OrganizationID,

        deaNumber: data.DEANumber,
        stateLicense: data.StateLicenseNumber,
        veterinarian: data.Veterinarian === 'Y',

        medicaidNumber: data.MedicaidNumber,
        upin: data.UPIN,
        data2000WaiverId: data.Data2000WaiverID,
        medicareNumber: data.MedicareNumber,
        mutuallyDefined: data.MutuallyDefined,
        remsHealthcareProviderEnrollmentId: data.REMSHealthcareProviderEnrollmentID,
        socialSecurity: data.SocialSecurity,
        certificateToPrescribe: data.CertificateToPrescribe,
        stateControlSubstanceNumber: data.StateControlSubstanceNumber,

        addressLine1: data.AddressLine1,
        addressLine2: data.AddressLine2,
        city: data.City,
        state: data.StateProvince,
        postalCode: data.PostalCode,
        countryCode: data.CountryCode,

        directAddress: data.DirectAddress,
        electronicMail: data.ElectronicMail, // unknow how to know
        primaryTelephone: data.PrimaryTelephone,
        primaryExtension: data.PrimaryExtension,
        primarySupportSms: data.PrimarySupportsSMS === 'Y',

        faxNumber: data.FaxNumber,
        faxExtension: data.FaxExtension,
        faxSupportSms: data.FaxSupportsSMS === 'Y',
        otherPhones: data.OtherPhones ? data.OtherPhones.map(item => {
          return {
            number: item.Number,
            qualifier: item.Qualifier,
            extension: item.Extension,
            supportsSms: item.SupportsSMS === 'Y'
          }
        }) : [],

        activeStartTime: moment(data.ActiveStartTime).format('MM/DD/YYYY hh:mm:ss A'),
        activeEndTime: moment(data.ActiveEndTime),

        optOutFlags: {
          renewalFaxOptOut: false,
          ciMailOptOut: false,
          ciFaxOptOut: false
        },
        backupPortalId: data.FaxBackup === 'Y',
        test: data.Test === 'Y',

        directorySpecialties: data.DirectorySpecialties ? data.DirectorySpecialties : [],
        useCases: data.UseCases ? data.UseCases : [],
        serviceLevels: data.ServiceLevels ? data.ServiceLevels : [],
        requestUpdateControlledSubstance: null
      }
    },
    async initDataModal () {
      try {
        this.deaText = ''
        let response = await httpClient.get(`/surescript/detail-doctor/${this.user.id}`)
        if (response.data.s === 200) {
          let detailDoctor = response.data.data.detailDoctor
          let deaData = response.data.data.deaData
          this.requestUpdateControlledSubstance = response.data.data.requestUpdate
          if (detailDoctor) {
            if (deaData) {
              const expirationDate = deaData.expirationDate
              if (!detailDoctor.DEANumber && expirationDate && moment().diff(moment(expirationDate)) < 0) {
                detailDoctor.DEANumber = deaData.number
                detailDoctor.StateLicenseNumber = deaData.state
              }
            }

            this.initDataUpdate(detailDoctor)
            this.modal = true
          } else {
            let dataUser = response.data.data.dataUser
            let location = response.data.data.location
            this.item = { ...this.item, ...dataUser }
            if (location) {
              this.item.city = location.city
              this.item.state = location.state
              this.item.postalCode = location.zipcode
              this.item.addressLine1 = location.address
            }
            this.deaText = 'N/A'
            if (deaData) {
              this.deaText = ''
              const expirationDate = deaData.expirationDate
              if (expirationDate) {
                if (moment().diff(moment(expirationDate)) > 0) {
                  this.deaText = `${deaData.number} - expired: ${this.formatTime(expirationDate)}`
                } else {
                  this.item.deaNumber = deaData.number
                  this.item.stateLicense = deaData.state
                }
              }
            }
            this.modal = true
          }
        } else {
          this.$emit('updateModal', false)
          this.alertError(response.data.msg)
        }
      } catch (e) {
        this.$emit('updateModal', false)
        this.alertError('Error when get data. Try again later')
      }
    },
    validateData () {
      let data = { s: true }
      let listFieldRequired = ['firstName', 'lastName', 'npi', 'addressLine1', 'city', 'state',
        'postalCode', 'countryCode', 'primaryTelephone', 'faxNumber', 'activeEndTime', 'serviceLevels']
      for (let i = 0; i < listFieldRequired.length; i++) {
        let key = listFieldRequired[i]
        if ((key === 'serviceLevels' && this.item[key].length === 0) || !this.item[key]) {
          data = { s: false, msg: `${key} is required` }
          return data
        }
        if (key === 'primaryTelephone' && this.item[key].length !== 10) {
          data = { s: false, msg: `Primary Phone number must be 10 digit` }
          return data
        }
        if (key === 'postalCode' && (this.item[key].length !== 10 && this.item[key].length !== 5)) {
          data = { s: false, msg: ` PostalCode must be a five or nine digit number` }
          return data
        }
      }
      //        /addressLine1
      let dataAddress = this.item.addressLine1.split(' ')
      if (dataAddress.length === 1) {
        data = { s: false, msg: `Address Line 1 must contain at least one whitespace character` }
        return data
      }
      if (this.item.otherPhones) {
        for (let i = 0; i < this.item.otherPhones; i++) {
          if (!this.item.otherPhones[i].qualifier) {
            data = { s: false, msg: `Type of contact is required` }
            return data
          }
          if (!this.item.otherPhones[i].number) {
            data = { s: false, msg: `Number of contact is required` }
            return data
          }
        }
      }
      return data
    },
    async syncDataDoctor () {
      try {
        let response = await httpClient.get(`/surescript/sync-data-doctor`, {
          params: {
            idWiki: this.user.id
          }
        })
        if (response.data.s === 200) {
          this.alertSuccess('Sync Successfully')
          let detailDoctor = response.data.data.detailDoctor
          this.initDataUpdate(detailDoctor)
          this.emitData()
        } else {
          this.alertError(response.data.msg)
        }
      } catch (e) {
        this.isProcessing = true
        console.log(e.message)
        this.alertError('Server error.Try again later')
      }
    },
    emitData () {
      this.$emit('updateDataDoctor', {})
    },
    async disableDoctor () {
      if (this.isProcessing) {
        return
      }
      this.isProcessing = true
      try {
        let response = await httpClient.post(`/surescript/disable-doctor`, {
          idWiki: this.user.id
        })
        this.isProcessing = false
        if (response.data.s === 200) {
          this.alertSuccess('Disabled Successfully')
          this.emitData()
          this.modal = false
        } else {
          this.alertError(response.data.msg)
        }
      } catch (e) {
        this.isProcessing = true
        this.alertError('Server error.Try again later')
      }
    },
    handleAction () {
      if (this.isEdit) {
        return this.updateDoctor()
      }
      this.createDoctor()
    },
    async updateDoctor () {
      if (this.isProcessing) {
        return
      }
      let validation = this.validateData()
      if (!validation.s) {
        this.alertError(validation.msg)
        return
      }
      this.isProcessing = true
      try {
        let data = this.item
        let response = await httpClient.post(`/surescript/update-doctor`, {
          dataSureScript: data,
          idWiki: this.user.id
        })
        this.isProcessing = false
        if (response.data.s === 200) {
          this.alertSuccess('Updated Successfully')
          this.emitData()
          this.modal = false
        } else {
          this.alertError(response.data.msg)
        }
      } catch (e) {
        this.isProcessing = true
        this.alertError('Server error.Try again later')
      }
    },
    async createDoctor () {
      if (this.isProcessing) {
        return
      }
      let validation = this.validateData()
      if (!validation.s) {
        this.alertError(validation.msg)
        return
      }
      this.isProcessing = true
      try {
        let data = this.item
        let response = await httpClient.post(`/surescript/create-doctor`, {
          dataSureScript: data,
          idWiki: this.user.id
        })
        this.isProcessing = false
        if (response.data.s === 200) {
          this.alertSuccess('Created Successfully')
          this.emitData()
          this.modal = false
        } else {
          this.alertError(response.data.msg)
        }
      } catch (e) {
        this.isProcessing = true
        this.alertError('Server error.Try again later')
      }
    },
    removeOtherPhones (index) {
      this.item.otherPhones.splice(index, 1)
    },
    addOtherPhone () {
      let item = { qualifier: 'HP', number: '', extension: '', supportsSms: false }
      this.item.otherPhones.push(item)
    },
    initData () {

    },
    closeModal () {
      this.modal = false
    },
    closeModalDetail () {
      this.modalDetail = false
    }
  }
}
</script>
<style>
#modalSurescriptCreateDoctor .mx-datepicker {
  width: 100%;
}

#modalSurescriptCreateDoctor .mx-input {
  height: 42px;
}

#modalSurescriptCreateDoctor .modal-dialog, #modalDetailSureScript .modal-dialog {
  width: 90% !important;
}

.multi-select-block .dropdown-toggle {
  border-radius: 0px !important;
}
</style>
<style scoped="">

.text-color {
  color: red;
}

.svg-inline--fa {
  height: 1em;
}

.card {
  position: relative;
  display: flex;
  flex-direction: column;
  min-width: 0;
  word-wrap: break-word;
  background-color: #fff;
  background-clip: border-box;
  border: 1px solid #dee2e6;
  border-radius: .25rem;
}

.card-body {
  flex: 1 1 auto;
  min-height: 1px;
  padding: 1rem;
}

.block-item-card {
  margin: 10px;
  display: block;
  float: left;
  width: 40%;
  height: 320px;
}

.block-item-card .card-header {
  background-color: #f8f9fa;
  padding: .5rem 1rem;
  margin-bottom: 0;
  border-bottom: 1px solid #dee2e6;
}

.block-item-card .card-footer {
  padding: .5rem 1rem;
  background-color: rgba(0, 0, 0, .03);
  border-top: 1px solid #dee2e6;
  width: 100%;
}

.text-muted {
  color: #adb5bd !important;
}

.block-item-card label {
  font-weight: 700;
  color: #6c757d;
  display: inline-block;
  margin-bottom: 0;
}

.block-item-card .form-text {
  display: block;
  margin-top: 0;
}

.item-header-nav {
  cursor: pointer;
  text-align: center;
  width: 270px;
  display: inline-block;
  background: #ebebeb;
  padding: 10px 15px;
  font-weight: bold;
}

.item-header-nav.active {
  background: white !important;
  color: #bec500;
}

</style>
